<template>
    <div class="search_prolist" v-infinite-scroll="loadMore" infinite-scroll-disabled='loading' infinite-scroll-distance='10'>
        <van-nav-bar title="商品列表" right-text="订单" @click-right="onClickRight"/>
        <div class="search_prolist_item" v-for='(item, index) in orderData' :key="index" @click="goProductDetail(item.id)">
            <div class="search_prolist_item_inner">
                <div class="search_prolist_cover">
                    <img class="photo" :src="item.cover_url"/>
                </div>
                <div class="search_prolist_info">
                    <div id="pro_info_above">
                        <div class="search_prolist_title" data-line="2">{{ item.name }}</div>
                        <div class="search_prolist_attr">{{ item.tag }}</div>
                    </div>
                    <div id="pro_info_below">
                        <div class="search_prolist_price">¥ {{ item.price }}</div>
                        <div class="search_prolist_other text_small">
                            <span class="search_prolist_comment">评分 {{ item.rate }}</span>
                            <span class="search_prolist_rate">点赞数 {{ item.star }}</span>
                        </div>
                        <div class="search_prolist_shop" nowxa="1">
                            <div class="shop_area"><span class="shop_name">{{ item.business_name }}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--显示加载中-->
        <div class="loading-box" v-if="isloading">
            <mt-spinner type="snake" class="loading-more"></mt-spinner>
            <span class="loading-more-txt">加载中...</span>
        </div>
        <!-- 显示没有更多 -->
        <div class="no-more" v-show="noMone">暂无更多数据</div>
        <tabbar :selected="selected"></tabbar>
    </div>
</template>

<script>
    import common from "../common";
    import {InfiniteScroll, Spinner} from 'mint-ui';
    import Vue from "vue";
    import tabbar from '@/components/tabbar'

    Vue.use(InfiniteScroll);
    Vue.component(Spinner.name, Spinner);
    export default {
        name: 'productlist',
        components: {tabbar},
        data() {
            return {
                selected: "productlist",
                msg: '商品列表',
                orderData: [],
                pageVal: 0,
                pageSize: "10",
                loading: false, //为true时不会触发加载更多，false可以触发
                isloading: false,//显示加载中
                noMone: false,//是否没有更多
                token: ""
            }
        },
        methods: {
            //获取列表
            getList() {
                let token = this.token;
                let querystring = require('querystring');
                this.$api.post('wx/service/productList',
                    querystring.stringify({
                        pageSize: this.pageSize,
                        pageNum: this.pageVal,
                        token: token
                    })
                ).then(data => {
                    if (this.pageVal < data.data.pageTotal) {
                        for (var i = 0; i < this.pageSize; i++) {
                            this.orderData.push(data.data.data[i]);
                        }
                        this.loading = false;
                    } else if (this.pageVal == data.data.pageTotal) {
                        for (var i = 0; i < data.data.data.length; i++) {
                            this.orderData.push(data.data.data[i]);
                        }
                        this.loading = false;
                    } else {
                        this.loading = true;
                        this.noMone = true;
                    }
                    this.isloading = false;
                }).catch(err => {
                    console.log(err);
                })
            },
            //分页加载更多
            loadMore() {
                this.loading = true;
                this.isloading = true;
                this.pageVal++;
                this.getList();
            },
            goProductDetail(id) {
                let obj = {
                    id: id,
                };
                let card_obj = JSON.stringify(obj);
                this.$router.push({
                    path: "/product/pay/" + card_obj
                });
            },
            onClickRight() {
                this.$router.push({path: "/order/list/"});
            },
        },
        mounted() {
            //判断cookie中是否存在token
            let ifcookietoken = document.cookie.indexOf("token=") != -1;
            if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
                this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
            } else if (ifcookietoken) {
                this.token = common.getCookie("token");
            } else {
                this.$router.replace({name: 'login'});
            }
        },
        beforeDestroy() {

        },
    }
</script>

<style scoped>
    .search_prolist .search_prolist_item_inner {
        position: relative;
        padding-left: 32vw;
    }

    .search_prolist .search_prolist_item {
        display: block;
        position: relative;
        padding: 5px 0 0 5px;
        background-color: #fff;
    }

    .search_prolist .search_prolist_cover {
        position: absolute;
        left: 0;
        top: 1vh;
        width: 120px;
        height: 120px;
        overflow: hidden;
    }

    .search_prolist .search_prolist_cover .photo {
        width: 120px;
    }

    .search_prolist .search_prolist_info {
        margin: 5px auto;
        min-height: 120px;
        padding-bottom: 5px;
        box-sizing: border-box;
        padding: 0 15px;
        overflow: hidden;
        line-height: 1;
    }

    .search_prolist .search_prolist_title {
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        height: 25px;
        word-break: break-all;
        margin-top: 5px;
        color: #333;
        line-height: 1.36;
        font-size: .45rem;
    }

    .search_prolist .search_prolist_attr {
        text-align: left;
        margin: 3px 0 1px;
        height: 15px;
        overflow: hidden;
        font-size: .35rem;
    }

    .search_prolist .search_prolist_price {
        text-align: right;
        display: inline-block;
        margin: 2px 0 2px 0;
        height: 22px;
        color: #e4393c;
        min-width: 100%;
        font-size: .45rem;
    }

    .search_prolist .search_prolist_other {
        text-align: left;
        font-size: .35rem;
        height: 20px;
        padding: 5px 0;
        box-sizing: border-box;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        line-height: 1.2;
    }

    .search_prolist .search_prolist_shop {
        text-align: left;
        box-sizing: border-box;
        padding-top: 5px;
        height: 5vh;
        color: #999;
        font-size: .35rem;
        overflow: hidden;
    }

    .loading-box {
        align-items: center;
        display: -webkit-flex;
        justify-content: center;
    }

    .no-more {
        width: 100VW;
        height: 10vh;
        text-align: center;
        line-height: 10vh;
        font-size: .4rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/productList.vue